import { ThemeModes } from '../../theme/theme'
import { useTheme } from '../../theme/useTheme'

const OPTIONS = [
  { value: ThemeModes.system, label: 'System' },
  { value: ThemeModes.light, label: 'Light' },
  { value: ThemeModes.dark, label: 'Dark' },
]

export default function ThemeToggle() {
  const { mode, setMode } = useTheme()

  return (
    <div className="inline-flex rounded-lg border border-outline bg-surface p-1" role="group" aria-label="Theme mode">
      {OPTIONS.map((option) => {
        const selected = mode === option.value
        return (
          <button
            key={option.value}
            type="button"
            onClick={() => setMode(option.value)}
            className={`rounded-md px-3 py-1.5 text-xs font-semibold transition ${
              selected
                ? 'bg-primary text-primary-foreground'
                : 'text-muted-foreground hover:bg-surface-elevated'
            }`}
          >
            {option.label}
          </button>
        )
      })}
    </div>
  )
}
